import React from "react";
import { useTranslation } from "react-i18next";
import type { U3134GenerateWipProgressData } from "../../U3134Service";
import { NS } from "../../U3134";

interface U3134GenerateWipProgressPanelProps {
  isOpen: boolean;
  progressPercent: number | null;
  progressData: U3134GenerateWipProgressData | null;
  onClose: () => void;
}

const U3134GenerateWipProgressPanel: React.FC<U3134GenerateWipProgressPanelProps> = ({ isOpen, progressPercent, progressData, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const current = progressData?.current ?? 0;
  const total = progressData?.total ?? 0;
  const employeeName = progressData?.currentItem?.employeeName ?? t("lblUnknownEmployee", { ns: NS });
  const percent = typeof progressPercent === "number" ? progressPercent : total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <aside className="fixed right-4 top-20 z-40 w-[380px] rounded-xl border border-gray-200 bg-white shadow-xl">
      <header className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <h3 className="text-sm font-semibold text-gray-800">{t("lblGenerateWipProgressTitle", { ns: NS })}</h3>
        <button type="button" className="text-gray-500 hover:text-gray-700" onClick={onClose}>
          x
        </button>
      </header>
      <div className="space-y-3 px-4 py-3 text-sm">
        <div className="text-gray-700">
          {t("lblGenerateWipCurrentOverTotal", { ns: NS, current, total })}
        </div>
        <div className="h-2 w-full rounded-sm bg-gray-200">
          <div className="h-2 rounded-sm bg-blue-600 transition-all duration-300" style={{ width: `${Math.max(0, Math.min(100, percent))}%` }} />
        </div>
        <div className="text-xs text-gray-600">{t("lblGenerateWipPercent", { ns: NS, percent })}</div>
        <div className="text-gray-700">
          {t("lblGenerateWipEmployeeInProgress", { ns: NS, employeeName })}
        </div>
      </div>
    </aside>
  );
};

export default U3134GenerateWipProgressPanel;
